// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Foliage_App_Component from "../Foliage.App.Component/index.js";
import * as Halogen_Aff_Util from "../Halogen.Aff.Util/index.js";
import * as Halogen_VDom_Driver from "../Halogen.VDom.Driver/index.js";
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Effect_Aff.bindAff);
var main = /* #__PURE__ */ Halogen_Aff_Util.runHalogenAff(/* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(/* #__PURE__ */ Effect_Class_Console.log(Effect_Aff.monadEffectAff)("[Foliage.App.Main]"))(function () {
    return bindFlipped(Halogen_VDom_Driver.runUI(Foliage_App_Component.component)({}))(Halogen_Aff_Util.awaitBody);
}));
export {
    main
};
